import { isArray } from '../tools';
export var modelToCallbacksMap = new Map();
export var callbackToModelsMap = new Map();
export var modelToRacePromisesMap = new Map();
var unsubscribe = function unsubscribe(targetDeps, callback) {
  var _targetDeps$length;
  if (!targetDeps && !callback) {
    modelToCallbacksMap.clear();
    callbackToModelsMap.clear();
    return;
  }
  if (callback) {
    var callbacks;
    if (isArray(callback)) {
      callbacks = callback;
    } else {
      callbacks = [callback];
    }
    var cl = callbacks.length;
    var delCallback = function delCallback(model, cbs) {
      if (cbs) {
        for (var j = 0; j < cl; j += 1) {
          var cb = callbacks[j];
          cbs.delete(cb);
          if (callbackToModelsMap.has(cb)) {
            callbackToModelsMap.delete(cb);
          }
        }
        if (cbs.size === 0) {
          modelToCallbacksMap.delete(model);
          var v = modelToRacePromisesMap.get(model);
          v === null || v === void 0 ? void 0 : v.clear();
          modelToRacePromisesMap.delete(model);
        }
      }
    };
    var _l = (targetDeps === null || targetDeps === void 0 ? void 0 : targetDeps.length) || 0;
    if (_l) {
      for (var i = 0; i < _l; i += 1) {
        var model = targetDeps === null || targetDeps === void 0 ? void 0 : targetDeps[i];
        var set = modelToCallbacksMap.get(model);
        delCallback(model, set);
      }
      return;
    }
    modelToCallbacksMap.forEach(function (cbSet, model) {
      delCallback(model, cbSet);
    });
    return;
  }
  var l = (_targetDeps$length = targetDeps === null || targetDeps === void 0 ? void 0 : targetDeps.length) !== null && _targetDeps$length !== void 0 ? _targetDeps$length : 0;
  for (var _i = 0; _i < l; _i += 1) {
    var _model = targetDeps === null || targetDeps === void 0 ? void 0 : targetDeps[_i];
    var _set = modelToCallbacksMap.get(_model);
    _set === null || _set === void 0 ? void 0 : _set.forEach(function (cb) {
      if (callbackToModelsMap.has(cb)) {
        callbackToModelsMap.delete(cb);
      }
    });
    _set === null || _set === void 0 ? void 0 : _set.clear();
    modelToCallbacksMap.delete(_model);
  }
};
export default unsubscribe;